module.exports = __webpack_public_path__ + "img/quadra.ccaab033.jpg";